import React from "react";
import {useDispatch, useSelector} from "react-redux";
import FormRow from "../../../../../Form/FormRow";
import {RootStore} from "../../../../../../store/Store";
import {
    CalendarSummary,
    CalendarTypeEnum,
    EventCalendarEntry,
    FrontlineCalendarEntry
} from "../../../../../../api/grs";
import {getAreaFromCalendarName} from "../../../Helpers/calenderEntryHelpers";
import {setCalendarEntry} from "../../../../../../store/calendarEntry/actions/CalendarEntryActions";

export type CalendarEntryAreaProps = EventCalendarEntry | FrontlineCalendarEntry;

export default function CalendarEntryArea(props: CalendarEntryAreaProps) {
    const dispatch = useDispatch();
    const calendarStore = useSelector((state: RootStore) => state.calendarSummaryList);
    const entry = props;
    const calendars =
        calendarStore.data?.filter(
            (x) =>
                x.calendarType === CalendarTypeEnum.Frontline &&
                !x.archived &&
                x.name !== "Drug Management"
        ) ?? [];
    const areas = calendars.map((x) => getAreaFromCalendarName(x.name));
    areas.sort((a, b) => a.localeCompare(b));
    const otherSelected = entry.area !== undefined ? !areas.includes(entry.area) : true;

    // Set the area on the current entry under modification
    function setArea(area: string) {
        const details: EventCalendarEntry | FrontlineCalendarEntry = {
            ...entry,
            area: area
        };

        dispatch(setCalendarEntry(details));
    }

    function onAreaChanged(e: React.ChangeEvent<HTMLSelectElement>) {
        const area = e.target.value;
        if (area !== "Other") setArea(area);
        else setArea("");
    }

    function onAreaCustomChanged(e: React.ChangeEvent<HTMLInputElement>) {
        const area = e.target.value;
        setArea(area);
    }

    // If no area set and we can set one, set it
    if (entry.area === undefined) {
        const initialArea = getInitialArea(entry.calendarId, calendars);
        if (initialArea !== null) setArea(initialArea);
    }

    return (
        <React.Fragment>
            <FormRow rowName="Operational Area" columnDetailClassName={"pl-0 pr-0"}>
                <div>
                    <select
                        className="select"
                        value={otherSelected ? "Other" : entry.area}
                        onChange={onAreaChanged}
                    >
                        {areas.map((area) => (
                            <option key={area} value={area}>
                                {area}
                            </option>
                        ))}
                        <option value="Other">Other</option>
                    </select>
                </div>

                {otherSelected && (
                    <div className="mt-1">
                        <input
                            placeholder="Enter Operational Area"
                            type="text"
                            className="input-fields"
                            value={entry.area}
                            onChange={onAreaCustomChanged}
                        />
                    </div>
                )}
            </FormRow>
        </React.Fragment>
    );
}

function getInitialArea(calendarId: number, calendars: CalendarSummary[]): string | null {
    if (calendars.length === 0) return null;

    const calendar = calendars.find((x) => x.id === calendarId);
    if (!calendar) return null;

    return getAreaFromCalendarName(calendar.name);
}
